import {initializeApp, FirebaseApp, FirebaseOptions} from 'firebase/app';
import {getRemoteConfig, isSupported} from 'firebase/remote-config';

import {RemoteConfigDefaults} from 'config/remoteConfigDefaults';
import {isUnitTestMode, StaticConfig} from 'config/staticConfig';
import {getValuesByKey} from 'utils/types';

const validateFirebaseConfig = (config: FirebaseOptions): FirebaseOptions | undefined =>
  Object.keys(config).reduce<boolean>((prevAnswer, key) => !!(prevAnswer && getValuesByKey(config, key)), true)
    ? config
    : undefined;

const registerFirebaseApp = (config?: FirebaseOptions): FirebaseApp | undefined => {
  if (!config || isUnitTestMode) {
    return undefined;
  }
  return initializeApp(config, config.appId);
};

export const registerRemoteConfig = (app?: FirebaseApp) =>
  isSupported().then((supported) => {
    const remoteConfig = app && supported ? getRemoteConfig(app) : undefined;
    if (remoteConfig) {
      remoteConfig.defaultConfig = RemoteConfigDefaults;
      remoteConfig.settings = {
        ...remoteConfig.settings,
        minimumFetchIntervalMillis: StaticConfig.firebaseRemoteConfigMinimumFetchInterval
      };
      return remoteConfig;
    }
    return undefined;
  });

export const webFirebaseApp = registerFirebaseApp(
  validateFirebaseConfig({
    apiKey: StaticConfig.firebaseApiKey,
    authDomain: StaticConfig.firebaseAuthDomain,
    projectId: StaticConfig.firebaseProjectId,
    storageBucket: StaticConfig.firebaseStorageBucket,
    messagingSenderId: StaticConfig.firebaseMessagingSenderId,
    appId: StaticConfig.firebaseAppId
  })
);

export const mobileFirebaseApp = StaticConfig.mobileApplicationMode
  ? registerFirebaseApp(
      validateFirebaseConfig({
        apiKey: StaticConfig.mobileFirebaseApiKey,
        authDomain: StaticConfig.mobileFirebaseAuthDomain,
        projectId: StaticConfig.mobileFirebaseProjectId,
        storageBucket: StaticConfig.mobileFirebaseStorageBucket,
        messagingSenderId: StaticConfig.mobileFirebaseMessagingSenderId,
        appId: StaticConfig.mobileFirebaseAppId
      })
    )
  : undefined;
